import { useEffect } from "react";

const EliteReferralWidget = () => {
    useEffect(() => {
        if (!document.querySelector('script[src="https://portal-widgets.lsqportal.com/assets/bootstrap-widget.js"]')) {
            const script = document.createElement('script');
            script.src = 'https://portal-widgets.lsqportal.com/assets/bootstrap-widget.js';
            script.setAttribute('data-widget-id', '33b181c8-cdb9-11ef-b491-02eda0793197');
            script.setAttribute('data-version-id', '166d015e-35f5-4909-b894-f97a3009ac30');
            script.setAttribute('data-formjs', 'https://forms.lsqportal.com/r21/js/lsq.form.js');
            script.setAttribute('data-URL', 'https://portal-widgets.lsqportal.com');
            script.setAttribute('onload', "window['___lsq-portal-widget-helpers___'].bootstrapLSQWidget(event)");
            script.Charset = 'utf-8';
        
            // Append the script to the div with id "sd"
            const widgetDiv = document.getElementById('lsq-portal-widget-33b181c8-cdb9-11ef-b491-02eda0793197-166d015e-35f5-4909-b894-f97a3009ac30');
            if (widgetDiv) {
                widgetDiv.appendChild(script);
            }
        }
    }, []);

    return (
        <div id="lsq-portal-widget-33b181c8-cdb9-11ef-b491-02eda0793197-166d015e-35f5-4909-b894-f97a3009ac30" className="lsq-portal-widget lsq-form-widget">
        </div>
    )
}
export default EliteReferralWidget;